// ================================================================
// «Warum bin ich abgemeldet?» — der Grund überlebt den Neustart
// ================================================================
// Das Problem: wer von einem anderen Gerät abgemeldet wird, erfährt es im
// Moment des Rauswurfs oft gar nicht — das Handy liegt in der Tasche. Er sieht
// den Effekt erst beim nächsten Öffnen der App. Bis dahin ist der auslösende
// 401 längst Geschichte und der Grund mit ihm.
//
// Also wird der Grund beim Rauswurf hier abgelegt und beim nächsten Zeichnen
// der Anmeldemaske EINMAL ausgelesen und dabei gelöscht — er gehört zu genau
// einem Rauswurf, nicht zu allen künftigen.
//
// localStorage und nicht sessionStorage: ein geschlossener Tab (oder eine
// beendete App) ist genau der Fall, für den das hier gebaut ist.

const KEY = 'levelupwerk:signedOutReason';

/**
 * Merkt sich, warum gerade abgemeldet wurde.
 * @param {string} code  Fehlercode vom Server, z.B. AUTH_SESSION_REVOKED_OTHER_DEVICE
 * @param {string|null} byDevice  Name des Geräts, das abgemeldet hat
 */
export function rememberSignOut(code, byDevice = null) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ code, byDevice, at: Date.now() }));
  } catch {
    // Privater Modus / voller Speicher: dann gibt es eben die neutrale
    // Anmeldemaske. Kein Grund, den Rauswurf selbst scheitern zu lassen.
  }
}

/** Liest den Grund EINMAL und löscht ihn dabei. null = gewöhnliche Anmeldung. */
export function takeSignOutReason() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    localStorage.removeItem(KEY);
    const parsed = JSON.parse(raw);
    // Ein Grund von letzter Woche erklärt die Anmeldemaske von heute nicht mehr.
    if (!parsed?.code || Date.now() - (parsed.at ?? 0) > 7 * 24 * 60 * 60 * 1000) return null;
    return parsed;
  } catch {
    return null;
  }
}

/** Erkennt an einem Fehler, ob es ein Rauswurf war (und nicht bloss Ablauf). */
export function isRevokedError(err) {
  return typeof err?.code === 'string' && err.code.startsWith('AUTH_SESSION_REVOKED');
}
